import { styled } from '@mui/material';

export const Container = styled('div')({
  width: '550px',
  maxWidth: '95%',
  transform: 'translate(-50%, -50%)',
  position: 'fixed',
  top: '50%',
  left: '50%',
  maxHeight: '95vh',
  border: '1px solid #d9d9d9',
  padding: '15px',
});

export const Logo = styled('div')({
  textAlign: 'center',
  marginBottom: 20,
});

export const Footer = styled('div')({
  fontSize: 13,
  textAlign: 'center',
  padding: '20px 0',
  color: '#596375',
});
